import { useQuery } from "@tanstack/react-query";
import { apiEndpoint } from "../utils/constants";
import { apiFetch } from "@core/index";
import { RolesListResponse } from "../utils/types";

export const useGetALlRolesList = () => {
  return useQuery<RolesListResponse>({
    queryKey: ["allRolesList"],
    queryFn: async () => {
      const url = `${apiEndpoint}/roles`;
      const data = await apiFetch(url);
      return data as RolesListResponse;
    },
  });
};
